import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import {
  ICartAppointmentCommentsResponse,
  ICartAppointmentCommentsResponseData,
} from "@/api_framework/api_modals/Cart";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const useCartAppointmentCommentsAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartAppointmentCommentsResponseData[]>([]);
  const [personaDiscountComments, setPersonaDiscountComments] = useState<string[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (customerId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${CART_MODULE?.CART_APPOINTMENT_COMMENTS?.baseURL}?customer_id=${customerId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartAppointmentCommentsResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data?.comments ?? []);
              setPersonaDiscountComments(res.data.data?.persona_discount_comments ?? []);
              return { status: true, message: "batch" };
            } else {
              setData([]);
              setPersonaDiscountComments([]);
              return { status: false, message: "cart_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            // captureError(e)
            //
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e) {
        // captureError(e);
      }
    },
    [dispatch],
  );
  return { data, personaDiscountComments, execute };
};
